import { font } from 'modules/styles';
import styled from 'styled-components';

export const Table = styled.table`
    width: 100%;
    table-layout: fixed;
`;

export const Cell = styled.td`
    border: 1px solid #cacccd;
    padding: 10px 20px;
`;

export const NameCell = styled(Cell)`
    width: 33%;
    background: #f9f9f9;
    text-transform: uppercase;
    ${font(11, '#7d7a7a', 'semibold')};
`;
